import React from "react";
import {
  Card,
  CardContent,
  Grid,
  CardActionArea,
  Button,
  Dialog,
  DialogTitle,
  Grow,
  Avatar,
  Box,
  Skeleton,
  DialogContent,
} from "@mui/material";

import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import head from "img/003.png";
import wrong from "img/004.png";
import correct from "img/005.png";
import scammer from "img/006.png";
import CloseIcon from "@mui/icons-material/Close";

import ico1 from "img/homeicon/01.png";
import ico2 from "img/homeicon/02.png";
import ico3 from "img/homeicon/03.png";
import ico4 from "img/homeicon/04.png";
import ico5 from "img/homeicon/05.png";
import ico6 from "img/homeicon/06.png";
import ico7 from "img/homeicon/07.png";
import ico8 from "img/homeicon/08.png";
import ico9 from "img/homeicon/09.png";
import ico10 from "img/homeicon/10.png";

import img01 from "img/041.jpg";
import img02 from "img/A-10.jpg";

import img03 from "img/B-01.jpg";
import img04 from "img/B-02.jpg";


const icon = 60;

const Home = ({ setPage }) => {
  const [mobileOpen, setMobileOpen] = React.useState(null);

  return (
    <>
      <Card style={{ backgroundColor: "#19459D" }}>
        <CardContent>
          <div className="d-flex justify-content-center">
            <img src={head} width="460vw" />
          </div>
          <div className="container mb-4 d-flex justify-content-center">
            <h5 className="ml-3 text-center" style={{ color: "#fff" }}>
              กบข. แจ้งเตือนอย่าหลงเชื่อคำเชิญชวนต่าง ๆ
              หรือการติดต่อแอบอ้างจากช่องทางอื่น ๆ ที่ใช้ชื่อ "กบข." หรือ
              "ตราสัญลักษณ์" ที่ไม่ใช่ช่องทางการสื่อสารหลักของ กบข.
              และขอให้หลีกเลี่ยงการกดลิงก์หรือเข้าเว็บไซต์ที่ไม่น่าเชื่อถือ
            </h5>
          </div>
          <Card className="mb-5 mt-2" style={{ backgroundColor: "#E6E7E8" }}>
            <CardContent className="container">
              <div className="d-flex justify-content-center">
                <h5 className="ml-3 text-center" style={{ color: "#19459D" }}>
                  หากคุณเคยเจอพฤติกรรมเหล่านี้
                  ให้สงสัยไว้ก่อนว่าเป็นแก๊งมิจฉาชีพ
                </h5>
              </div>
              {window.innerWidth < 1000 ? (
                <img src={scammer} width="100%" />
              ) : (
                <img
                  src={scammer}
                  width="300px"
                  style={{ position: "absolute", zIndex: 1030, left: 10 }}
                />
              )}
              <Grid container className="mt-2">
                <Grid item md={6}>
                  <div className="text-danger d-flex justify-content-center">
                    <img src={wrong} width="300vw" />
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico1} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-3" style={{ fontSize: 18 }}>
                      ใช้เบอร์ส่วนตัวโทรหา
                    </span>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico2} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-3" style={{ fontSize: 18 }}>
                      อ้างเรื่องการจ่ายเงินปันผล
                    </span>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico3} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-3" style={{ fontSize: 18 }}>
                      ชักชวนลงทุน บอกว่าให้ผลตอบแทนสูง
                    </span>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico4} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-3" style={{ fontSize: 18 }}>
                      ให้โอนเงินเข้าบัญชีส่วนบุคคล
                    </span>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico5} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-3" style={{ fontSize: 18 }}>
                      ส่งข้อความให้กดลิงก์ เพื่อรับรางวัล
                    </span>
                  </div>
                </Grid>
                <Grid item md={6}>
                  <div className="text-success d-flex justify-content-center">
                    <img src={correct} width="280vw" />
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico6} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-3" style={{ fontSize: 18 }}>
                      กบข. ไม่ใช้เบอร์ส่วนตัวโทรหาสมาชิก จะใช้เบอร์&nbsp;
                      <b>02-6361000</b>
                    </span>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico7} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-3" style={{ fontSize: 18 }}>
                      กบข. ไม่มีการจ่ายเงินปันผล
                    </span>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico8} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-3" style={{ fontSize: 18 }}>
                      กบข. ไม่มีการชักชวนสมาชิกลงทุน
                    </span>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico9} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-0" style={{ fontSize: 18 }}>
                      กบข. ไม่ให้สมาชิกโอนเงินเข้าบัญชีตนเอง
                      ต้องแจ้งการออมผ่านหน่วยงานต้นสังกัดเท่านั้น
                    </span>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      marginLeft: window.innerWidth * 0.02,
                      color: "#19459D",
                    }}>
                    <Avatar src={ico10} sx={{ width: icon, height: icon }} />{" "}
                    <span className="pt-3" style={{ fontSize: 18 }}>
                      กบข. ยกเลิกการส่งข้อความที่มีการแนบลิงก์ทั้งหมด
                    </span>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2} className="mt-1">
                <Grid item md xs={12}>
                  <iframe
                    style={{ position: "initial !important" }}
                    src="https://www.youtube.com/embed/B9e4zabcBk4"
                    className="if"
                    width="100%"
                    height={300}
                  />
                </Grid>
                <Grid onClick={() => setMobileOpen(true)} item md={4} xs={12}>
                  <img src={img03} />
                </Grid>
                <Grid onClick={() => setMobileOpen(true)} item md={4} xs={12}>
                  <img src={img04} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </CardContent>
      </Card>

      <Dialog
        maxWidth="lg"
        TransitionComponent={Grow}
        fullScreen={window.innerWidth < 800 ? true : false}
        onClose={() => setMobileOpen(null)}
        open={mobileOpen != null}>
        <div className="text-right m-4">
          <CloseIcon onClick={() => setMobileOpen(null)} />
        </div>
        <DialogContent>
          <img src={img03} width="100%" height="auto" />
        </DialogContent>
      </Dialog>

      <Dialog
        maxWidth="lg"
        TransitionComponent={Grow}
        fullScreen={window.innerWidth < 800 ? true : false}
        onClose={() => setMobileOpen(null)}
        open={mobileOpen != null}>
        <div className="text-right m-4">
          <CloseIcon onClick={() => setMobileOpen(null)} />
        </div>
        <DialogContent>
          <img src={img04} width="100%" height="auto" />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Home;
